import { useEffect } from 'react'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'
import { useTranslation } from 'react-i18next'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { Errcode } from 'src/constants/errcode'

import { ResponseDataType } from 'src/types/websocket'
import { SocketSender } from 'src/api/socket'
import { eventBus } from 'src/api/eventBus'
import { useLocation } from 'react-router-dom'

const useHomeEventBus = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()
  useEffect(() => {
    const EmergencyContactResponseListener = eventBus.subscribe<unknown>(
      Cmdtypes.PHONE_NUMBER_UPDATE,
      handleEmergencyContactUpdateResponse,
    )
    const LockMsgResponseListener = eventBus.subscribe<unknown>(
      Cmdtypes.LOCK_MSG_UPDATE,
      handleLockMsgUpdateResponse,
    )

    return () => {
      EmergencyContactResponseListener.unsubscribe()
      LockMsgResponseListener.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const handleEmergencyContactUpdateResponse = (message: ResponseDataType<unknown>) => {
    const { Header } = message.responseData
    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(SocketSender(Cmdtypes.HOME_INFO))
      dispatch(
        setModalItems({
          type: 'alert',
          text: t('MODAL.HOME_CONTACT_SUCCESS', {
            defaultValue: 'Emergency contact updated successfully.',
          }) as string,
        }),
      )
    } else console.error(Header)
  }
  const handleLockMsgUpdateResponse = (message: ResponseDataType<unknown>) => {
    const { Header } = message.responseData
    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(SocketSender(Cmdtypes.HOME_INFO))
      dispatch(
        setModalItems({
          type: 'alert',
          text: `${t('MODAL.HOME_SCREEN_SUCCESS', {
            defaultValue: 'Lock Screen message updated successfully.',
          })}`,
        }),
      )
    } else console.error(Header)
  }
}
export default useHomeEventBus
